module.exports = __webpack_public_path__ + "media/images/facebook-a0a3813eecee06e3735a044910af6823.png";